import React, { useRef, useEffect } from 'react';
import './HtmlContentIframe.scss';

const HtmlContentIframe = ({ htmlContent }: { htmlContent: string }) => {
  const containerRef = useRef(null);

  const handleSubmit = () => {
    const data = document.getElementsByName('data');
    if (data) {
      const value = JSON.parse(data[0].value);
      if (window.self !== window.top) {
        data[0].setAttribute('value', JSON.stringify(value));
      }

      document.getElementById('gateway').submit();
    }
  };

  useEffect(() => {
    if (containerRef.current) {
      // Insert HTML content into the container
      containerRef.current.innerHTML = htmlContent;
      // Find and execute script tags
      const scripts = containerRef.current.getElementsByTagName('script');
      for (let script of scripts) {
        const newScript = document.createElement('script');
        if (script.src) {
          newScript.src = script.src;
        } else {
          newScript.innerHTML = script.innerHTML;
        }
        document.body.appendChild(newScript);
        document.body.removeChild(newScript); // Clean up
      }
      handleSubmit();
    }
  }, [htmlContent]);
  return <div ref={containerRef}></div>;
};

export default HtmlContentIframe;
